// theme constant
export const gridSpacing = 3;
export const drawerWidth = 260;
export const appDrawerWidth = 320;

// ログ調査リクエストの検索条件のデフォルトを OR に設定
export const DEFAULT_MODE = '1';
